/**
 * Trigger source — identifies which external provider sent a webhook.
 *
 * Single source of truth shared between frontend and backend.
 * Used for dispatch in WebhookVerifierRegistry, NewsMonitorRegistry, and ReceiveWebhookUseCase.
 */
export const TriggerSource = {
  WEBHOOK: "WEBHOOK",
  PIPEDREAM: "PIPEDREAM",
  MONITOR: "MONITOR",
  SCHEDULE: "SCHEDULE",
  PLATFORM_LISTENER: "PLATFORM_LISTENER"
} as const;

export type TriggerSource = (typeof TriggerSource)[keyof typeof TriggerSource];

/** Specific news monitor provider — stored in config.monitorProvider, not in Trigger.source */
export const MonitorProvider = {
  PARALLEL_AI: "PARALLEL_AI",
  EXA: "EXA"
} as const;

export type MonitorProvider = (typeof MonitorProvider)[keyof typeof MonitorProvider];
